import { render, staticRenderFns } from "./ListagemPontosAtualizados.vue?vue&type=template&id=5e548f06&scoped=true&"
import script from "./ListagemPontosAtualizados.vue?vue&type=script&lang=js&"
export * from "./ListagemPontosAtualizados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e548f06",
  null
  
)

export default component.exports